export const fontSizeNormal = '14px'
export const fontSizeLarge1 = '20px'
export const fontSizeLarge2 = '19px'
